import { useEffect, useMemo } from 'react';
import { Compartment } from '@codemirror/state';
import { githubDark } from '@fsegurai/codemirror-theme-github-dark';
import { githubLight } from '@fsegurai/codemirror-theme-github-light';
import { useTheme } from 'styled-components';
const themeCompartment = new Compartment();
export const useCodeHighlighting = (viewRef) => {
    const { themeId } = useTheme();
    const theme = themeId === 'primaryDark' ? githubDark : githubLight;
    useEffect(() => {
        viewRef.current?.dispatch({ effects: themeCompartment.reconfigure(theme) });
    }, [viewRef, theme]);
    return useMemo(() => themeCompartment.of(theme), [theme]);
};
